export const protectedTextFieldProps = {
  onCopy: (e: React.ClipboardEvent<HTMLInputElement>) => e.preventDefault(),
  onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => e.preventDefault(),
  onCut: (e: React.ClipboardEvent<HTMLInputElement>) => e.preventDefault(),
  onDrop: (e: React.DragEvent<HTMLInputElement>) => e.preventDefault(),
};
